import { render, staticRenderFns } from "./contentAnalysis.vue?vue&type=template&id=4f566544&scoped=true"
import script from "./contentAnalysis.vue?vue&type=script&lang=js"
export * from "./contentAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f566544",
  null
  
)

export default component.exports